import { getView, requireAuth } from '@/lib/utils';
import { AssetsPage } from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/inventory',
  component: getView('pages/PageDosing'),
  name: 'inventory',
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'ANALYTICS - Inventory',
    leftMenu: Left.AnalyticsPage,
    roles: ['operator'],
    information: AssetsPage,
    showBottomMenu: true,
    isFlowChem: false,
    crumbsIcon: 'flow-dosing',
  },
};
